import { getIn } from 'immutable';



const root = 'provider';

export const getBlockNumber = (state) =>
  getIn(state, [root, 'blockNumber'], null);

export const getChainId = (state) =>
  getIn(state, [root, 'chainId'], null);
